import { g as __rest, b as __assign } from '../../../_tslib-7a01aab4.js';
import React, { useContext } from 'react';
import { c as classNames } from '../../../index-e609ebf3.js';
import { AccordionItemRenderContext } from './context.js';
import '../../../_commonjsHelpers-17aad09c.js';

/**
 * @name AccordionItemComponent
 * @param {number | string} id
 * @param {number} index
 * @param {HTMLElement} children
 // * @param {*} focusRef
 * @param {Function} onRowClick
 * @param {number[]} openedItem
 */
var AccordionItemComponent = function (_a) {
    var id = _a.id, index = _a.index, children = _a.children, onRowClick = _a.onRowClick, openedItem = _a.openedItem;
    var isOpened = openedItem.includes(index);
    return (React.createElement(AccordionItemRenderContext.Provider, { value: {
            index: index,
            isOpened: isOpened,
            onRowClick: onRowClick,
            openedItem: openedItem,
        } },
        React.createElement("div", { className: "game-history-row-group ".concat(isOpened ? 'open' : ''), id: String(id) }, children)));
};
var Column = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: 'game-history-r-column' }, children);
};
var Title = function (_a) {
    var _b;
    var text = _a.text, type = _a.type;
    var className = classNames('game-history-r-c-text', (_b = {}, _b[type] = type, _b));
    return React.createElement("span", { className: className }, text);
};
var Icon = function (_a) {
    var _b;
    var _c = _a.iconName, iconName = _c === void 0 ? '' : _c;
    var className = classNames('icon-arrow-down', (_b = {}, _b[iconName] = iconName, _b));
    return React.createElement("i", { className: className });
};
var Row = function (_a) {
    var _b;
    var onClick = _a.onClick, children = _a.children, _c = _a.className, className = _c === void 0 ? '' : _c;
    var classNameList = classNames('game-history-row', (_b = {}, _b[className] = className, _b));
    return (React.createElement("div", { className: classNameList, onClick: onClick }, children));
};
var Panel = function (_a) {
    var className = _a.className, children = _a.children;
    return React.createElement("div", { className: className }, children);
};
var Header = function (_a) {
    var _b;
    var children = _a.children, className = _a.className, onClose = _a.onClose, restProps = __rest(_a, ["children", "className", "onClose"]);
    var _c = useContext(AccordionItemRenderContext), index = _c.index, isOpened = _c.isOpened, onRowClick = _c.onRowClick;
    var handleRowClick = function () {
        if (onClose && !isOpened) {
            onClose(!isOpened);
        }
        onRowClick(index);
    };
    var classNameList = classNames('head', (_b = {}, _b[className] = className, _b.open = isOpened, _b));
    return (React.createElement("div", __assign({ onClick: handleRowClick, className: classNameList }, restProps), children));
};
var AccordionItem = Object.assign(AccordionItemComponent, {
    Column: Column,
    Title: Title,
    Icon: Icon,
    Row: Row,
    Panel: Panel,
    Header: Header,
});

export { AccordionItem, AccordionItemComponent };
